import { QueryClient } from '@tanstack/react-query';

// One shared cache for the whole app. Tuned for an admin console:
// - staleTime 60s so a list fetched on one route is reused (not refetched) when
//   another route needs it within the minute — the "fetch once, reuse everywhere"
//   behavior. Slow per-event stats override this with a longer staleTime locally.
// - no refetchOnWindowFocus: operators tab away constantly; surprise refetches
//   are noise, not value.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Dev affordance: inspect the shared cache from the console (e.g.
// `__qc.getQueryCache().findAll({ queryKey: ['events','detail'] })`).
if (import.meta.env.DEV) {
  (window as unknown as { __qc: QueryClient }).__qc = queryClient;
}
